import React, { useState } from "react";

import {
  RelatorioAtendimentoMesAtual,
  RelatorioEvolucaoPeriodo,
  RelatorioPobreza,
  RelatorioRankingMunicipios,
  RelatorioSituacional,
  RelatorioDadosDemograficos,
  RelatorioCartaoCria,
} from "../../../components/DashboardPDF";

import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";

import * as S from "./styles";

import { Button, CircularProgress } from "@mui/material";
import { Download } from "@mui/icons-material";
import Title from "components/Title";
import {
  getCartaoCria,
  getCitiesRanking,
  getCurrentMonthReport,
  getDemographic,
  getEvolutionByPeriod,
  getPoverty,
  getSituations,
} from "utils/reportFunctions";
import dayjs from "dayjs";
import { Buffer } from 'buffer';
global.Buffer = Buffer;

const ReportsPage = () => {
  const [
    isLoadingEvolutionByPeriodReportData,
    setIsLoadingEvolutionByPeriodReportData,
  ] = useState(false);
  const [hasEvolutionByPeriodReportData, setHasEvolutionByPeriodReportData] =
    useState(false);
  const [evolutionByPeriodData, setEvolutionByPeriodData] = useState([]);

  const [
    isLoadingCitiesRankingReportData,
    setIsLoadingCitiesRankingReportData,
  ] = useState(false);
  const [hasCitiesRankingReportData, setHasCitiesRankingReportData] =
    useState(false);
  const [citiesRankingData, setCitiesRankingData] = useState([]);

  const [isLoadingSituationsReportData, setIsLoadingSituationsReportData] =
    useState(false);
  const [hasSituationsReportData, setHasSituationsReportData] = useState(false);
  const [situationsData, setSituationsData] = useState({
    familiesType: [],
    beneficiariesType: [],
  });

  const [isLoadingDemographicReportData, setIsLoadingDemographicReportData] =
    useState(false);
  const [hasDemographicReportData, setHasDemographicReportData] =
    useState(false);
  const [demographicData, setDemographicData] = useState({
    state: {
      racesType: [],
      gendersType: [],
      educationLevelsType: [],
    },
    cities: [],
  });

  const [isLoadingPovertyReportData, setIsLoadingPovertyReportData] =
    useState(false);
  const [hasPovertyReportData, setHasPovertyReportData] = useState(false);
  const [povertyData, setPovertyData] = useState({
    extremaPobreza: [],
    pobreza: [],
  });

  const [isLoadingCurrentMonthReportData, setIsLoadingCurrentMonthReportData] =
    useState(false);
  const [hasCurrentMonthReportData, setHasCurrentMonthReportData] =
    useState(false);
  const [currentMonthData, setCurrentMonthData] = useState([]);

  const [isLoadingCartaoCriaReportData, setIsLoadingCartaoCriaReportData] =
    useState(false);
  const [hasCartaoCriaReportData, setHasCartaoCriaReportData] = useState(false);
  const [cartaoCriaData, setCartaoCriaData] = useState([
    {
      city: "",
      extremaPobreza: [],
      pobreza: [],
      additionalInfo: {
        totalCriancas0a6: 0,
        beneficiariosAtivos: 0,
        beneficiariosInativos: 0,
        gestantes: 0,
        criancasComZica: 0,
        criancasAte6Anos: 0,
        gemeos: 0,
      },
    },
  ]);

  const getEvolutionByPeriodData = async () => {
    setIsLoadingEvolutionByPeriodReportData(true);
    try {
      const evolutionByPeriod = await getEvolutionByPeriod();
      setEvolutionByPeriodData(evolutionByPeriod);
      setHasEvolutionByPeriodReportData(true);
      return evolutionByPeriod;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingEvolutionByPeriodReportData(false);
    }
  };

  const getCitiesRankingData = async () => {
    setIsLoadingCitiesRankingReportData(true);
    try {
      const citiesRanking = await getCitiesRanking();
      setCitiesRankingData(citiesRanking);
      setHasCitiesRankingReportData(true);
      return citiesRanking;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingCitiesRankingReportData(false);
    }
  };

  const getSituationsData = async () => {
    setIsLoadingSituationsReportData(true);
    try {
      const situations = await getSituations();
      setSituationsData(situations);
      setHasSituationsReportData(true);
      return situations;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSituationsReportData(false);
    }
  };

  const getDemographicData = async () => {
    setIsLoadingDemographicReportData(true);
    try {
      const demographic = await getDemographic();
      setDemographicData(demographic);
      setHasDemographicReportData(true);
      return demographic;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingDemographicReportData(false);
    }
  };

  const getPovertyData = async () => {
    setIsLoadingPovertyReportData(true);
    try {
      const poverty = await getPoverty();
      setPovertyData(poverty);
      setHasPovertyReportData(true);
      return poverty;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingPovertyReportData(false);
    }
  };

  const getCartaoCriaData = async () => {
    setIsLoadingCartaoCriaReportData(true);
    try {
      const cartaoCria = await getCartaoCria();
      setCartaoCriaData(cartaoCria);
      setHasCartaoCriaReportData(true);
      return cartaoCria;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingCartaoCriaReportData(false);
    }
  };

  const getCurrentMonthData = async () => {
    setIsLoadingCurrentMonthReportData(true);
    try {
      const currentMonth = await getCurrentMonthReport();
      setCurrentMonthData(currentMonth);
      setHasCurrentMonthReportData(true);
      return currentMonth;
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingCurrentMonthReportData(false);
    }
  };

  const downloadPDF = async (event, component, downloadName, setLoading) => {
    event?.preventDefault(); // prevent page reload
    setLoading(true);
    try {
      const blob = await pdf(component).toBlob();
      saveAs(blob, `${downloadName}.pdf`);
    } catch (error) {
      console.error(`Erro ao baixar o relatório ${downloadName}`, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.ReportsContainer>
      <S.AllDataWrapper>
        <S.ReportsHeaderTexts>
          <Title
            titleText="Relatórios"
            subtitleTexts={["Início", "Relatórios"]}
          />
        </S.ReportsHeaderTexts>
        <S.ReportContainer>
          <h3 className="title">Relatório de Atendimento do Mês Atual</h3>
          <p className="subtitle">
            Números de atendimentos mensais do Cartão Cria de Janeiro de{" "}
            {dayjs().get("year")} até o mês corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                const currentMonth = hasCurrentMonthReportData
                  ? currentMonthData
                  : await getCurrentMonthData();

                console.log(currentMonth)
                downloadPDF(
                  e,
                  <RelatorioAtendimentoMesAtual
                    th
                    col={["10%", "50%", "40%"]}
                    children={[
                      ["Nº", "Mês", "Atendimentos"],
                      ...currentMonth.map((item, index) => [
                        index + 1,
                        item.month,
                        item.total,
                      ]),
                    ]}
                  />,
                  "relatorio-atendimento-mensal",
                  setIsLoadingCurrentMonthReportData
                );
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingCurrentMonthReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingCurrentMonthReportData}
            >
              {isLoadingCurrentMonthReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório de Ranking de Municípios</h3>
          <p className="subtitle">
            Ranking dos 10 municípios com o maior número de gestantes do início
            do ano até a data corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                const citiesRanking = hasCitiesRankingReportData
                  ? citiesRankingData
                  : await getCitiesRankingData();
                downloadPDF(
                  e,
                  <RelatorioRankingMunicipios
                    th
                    col={["10%", "48%", "42%"]}
                    children={[
                      ["Nº", "Município", "Quantidade de Gestantes"],
                      ...citiesRanking.map((item, index) => [
                        index + 1,
                        item.city,
                        item.total,
                      ]),
                    ]}
                  />,
                  "relatorio-ranking-municipios",
                  setIsLoadingCitiesRankingReportData
                );
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingCitiesRankingReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingCitiesRankingReportData}
            >
              {isLoadingCitiesRankingReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório de Evolução por Período</h3>
          <p className="subtitle">
            Quantativo de beneficiárias do ano atual, até a presente data, em
            comparação ao ano anterior.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                const evolutionByPeriod = hasEvolutionByPeriodReportData
                  ? evolutionByPeriodData
                  : await getEvolutionByPeriodData();
                downloadPDF(
                  e,
                  <RelatorioEvolucaoPeriodo
                    th
                    colTableOne={["20%", "40%", "40%"]}
                    currentYear={dayjs(new Date()).get("year")}
                    tableOne={[
                      ["Nº", "Mês", "Atendimentos"],
                      ...evolutionByPeriod.map((item) => [
                        item.year,
                        item.text,
                        item.total,
                      ]),
                    ]}
                    colTableTwo={["30%", "70%"]}
                    tableTwo={[
                      ["Meses", "Quantidade de Solicitações"],
                      ["Janeiro", "12.394"],
                      ["Fevereiro", "6.379"],
                      ["Março", "19.773"],
                    ]}
                  />,
                  "relatorio-evoluacao-periodo",
                  setIsLoadingEvolutionByPeriodReportData
                );
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingEvolutionByPeriodReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingEvolutionByPeriodReportData}
            >
              {isLoadingEvolutionByPeriodReportData
                ? "Baixando..."
                : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório Situacional</h3>
          <p className="subtitle">
            Diagnósticos situacionais das beneficiárias por tipo de cadastro e
            por tipo de família do início do ano até a data corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                const situations = hasSituationsReportData
                  ? situationsData
                  : await getSituationsData();
                downloadPDF(
                  e,
                  <RelatorioSituacional
                    th
                    colTableOne={["70%", "30%"]}
                    currentYear={dayjs(new Date()).get("year")}
                    tableOne={[
                      ["Tipo de Cadastro", "Quantitativo"],
                      ...situations.beneficiariesType.map((item) => [
                        item.type,
                        item.total,
                      ]),
                    ]}
                    colTableTwo={["70%", "30%"]}
                    tableTwo={[
                      ["Tipo de Família", "Quantitativo"],
                      ...situations.familiesType.map((item) => [
                        item.type,
                        item.total,
                      ]),
                    ]}
                  />,
                  "relatorio-situacional",
                  setIsLoadingSituationsReportData
                );
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingSituationsReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingSituationsReportData}
            >
              {isLoadingSituationsReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório de Dados Demográficos</h3>
          <p className="subtitle">
            Quantitativo das beneficiárias de Alagoas e de cada município,
            separados por raça, sexo e instrução do início do ano até a data
            corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                try {
                  setIsLoadingDemographicReportData(true);
                  const demographic = await getDemographicData();

                  await downloadPDF(
                    e,
                    <RelatorioDadosDemograficos
                      th
                      colTableOne={["70%", "30%"]}
                      currentYear={dayjs(new Date()).get("year")}
                      tableOne={demographic?.state.racesType}
                      tableCities={demographic?.cities}
                      colTableTwo={["70%", "30%"]}
                      tableTwo={demographic?.state.gendersType}
                      colTableThree={["70%", "30%"]}
                      tableThree={demographic?.state.educationLevelsType}
                    />,
                    "relatorio-dados-demograficos",
                    setIsLoadingDemographicReportData
                  );
                } catch (err) {
                  console.error(err);
                } finally {
                  setIsLoadingDemographicReportData(false);
                }
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingDemographicReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingDemographicReportData}
            >
              {isLoadingDemographicReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório de Pobreza</h3>
          <p className="subtitle">
            Crianças em pobreza ou extrema pobreza separadas por faixa etária.
            Dados do início do ano até a data corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                const poverties = hasPovertyReportData
                  ? povertyData
                  : await getPovertyData();
                downloadPDF(
                  e,
                  <RelatorioPobreza
                    th
                    colTableOne={["70%", "30%"]}
                    currentYear={dayjs(new Date()).get("year")}
                    tableOne={poverties.extremaPobreza}
                    colTableTwo={["70%", "30%"]}
                    tableTwo={poverties.pobreza}
                  />,
                  "relatorio-pobreza",
                  setIsLoadingPovertyReportData
                );
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingPovertyReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingPovertyReportData}
            >
              {isLoadingPovertyReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>

        <S.ReportContainer>
          <h3 className="title">Relatório do Cartão CRIA</h3>
          <p className="subtitle">
            Quantitativo de pessoas cadastrados em familías em situação de
            pobreza e de extrema pobreza de cada município e a situação
            cadastral do município. Dados do início do ano até a data corrente.
          </p>
          <div className="buttonGroup">
            <Button
              onClick={async (e) => {
                try {
                  const cartaoCria = await getCartaoCriaData();
                  await downloadPDF(
                    e,
                    <RelatorioCartaoCria
                      th
                      colTableOne={["70%", "30%"]}
                      tableCities={cartaoCria}
                    />,
                    "relatorio-cartao-cria",
                    setIsLoadingCartaoCriaReportData
                  );
                } catch (error) {
                  console.error(error, "relatorio cria");
                }
              }}
              variant="contained"
              className="btn-search"
              startIcon={
                isLoadingCartaoCriaReportData ? (
                  <CircularProgress size={20} />
                ) : (
                  <Download />
                )
              }
              sx={{
                background: " var(--Light-Verde---light, #88C54B)",
                width: "180px",
                height: "54px",
                padding: "15px 16px",
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 300,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#88C54B",
                },
              }}
              disabled={isLoadingCartaoCriaReportData}
            >
              {isLoadingCartaoCriaReportData ? "Baixando..." : "Baixar PDF"}
            </Button>
          </div>
        </S.ReportContainer>
      </S.AllDataWrapper>
    </S.ReportsContainer>
  );
};

export default ReportsPage;
